import {PaymentProvider} from "@irati/payments/enums/PaymentV2"

import {isCheckoutDotComEnabled} from "../services/Payments"

export default async function paymentProviderForCountryCode() {
  if (await isCheckoutDotComEnabled()) {
    return PaymentProvider.CheckoutCom
  }
  return PaymentProvider.Adyen
}
